import React, { useState, useEffect } from 'react'
import ModalDialog from '../../layouts/ModalDialog'
import NewTrait from './NewTrait'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTraits, deleteTrait, clearDeletedTrait } from '../../../store/actions/traitsActions'
import Loader from '../../elements/Loader'
import EmptyState from '../../elements/EmptyState'
import PlusIcon from '../../elements/icons/PlusIcon'
import TrashIcon from '../../elements/icons/TrashIcon'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import EditTrait from './EditTrait'

const Traits = () => {
    const dispatch = useDispatch()
    const traitsSelector = useSelector(state => state.traits)
    const [reload, setReload] = useState(0)

    useEffect(() => {
        dispatch(fetchTraits())

        if(traitsSelector.deletedTrait !== null) {
            dispatch(clearDeletedTrait())
        }
    }, [dispatch, reload, traitsSelector.deletedTrait])

    const [creatingTrait, setCreatingTrait] = React.useState(false)
    const [activeTrait, setActiveTrait] = React.useState(null)

    const handleDeleteTrait = (traitId) => {
        if(window.confirm('Are you sure you want to delete this trait? This action cannot be undone.')) {
            dispatch(deleteTrait(traitId))
        }
    }

    return (
        <>
            <div className="w-full">
                {traitsSelector.loadingTraits ? 
                    <Loader />
                :
                    <div className='w-full'>
                        {traitsSelector?.traits?.traits?.length > 0 ? 
                            <div>
                                {traitsSelector?.traits?.traits?.map((trait, traitIndex)=>(
                                    <div 
                                        key={traitIndex} 
                                        className="w-full rounded-lg bg-white p-5 mb-4 border border-gray-200 relative"
                                    >
                                        <div className="absolute top-2 right-2 flex flex-row-reverse items-center gap-x-2">
                                            <button onClick={()=>{handleDeleteTrait(trait._id)}} className='p-1.5 bg-gray-100 rounded bg-transparent hover:bg-red-100 transition duration-200 text-gray-500 hover:text-vcm-purple'>
                                                <TrashIcon className={`w-4 h-4`} />
                                            </button>

                                            <button onClick={()=>{setActiveTrait(trait)}} className='text-xs font-space-grotesk flex flex-row items-center gap-x-1 text-vcm-purple hover:text-gray-400 transition duration-200 p-1.5 bg-gray-100 rounded bg-transparent hover:bg-gray-200'>
                                                View/Edit Trait 
                                                <ArrowIcon className={`w-4 h-4`} />
                                            </button>
                                        </div>

                                        <h3 className="font-semibold text-sm text-gray-800">{trait.name}</h3>
                                        <p className="text-sm text-gray-500">{trait.description}</p>
                                    </div>
                                ))}

                            </div>
                            :
                            <div>
                                <EmptyState 
                                    emptyStateTitle="No Traits Available" 
                                    emptyStateText="There are currently no academic traits available. Please add new traits to get started." 
                                />
                            </div>
                        }
                        <button onClick={()=>{setCreatingTrait(true)}} className='w-max mx-auto p-3 text-xs border border-dashed border-gray-500 bg-white transition duration-200 flex items-center justify-center gap-x-1 text-gray-800 rounded-lg mt-2 font-space-grotesk font-semibold'>
                        <PlusIcon className={`w-4 h-4 inline-block`} />
                            Add New Trait
                        </button>
                    </div>
                }
            </div>

            <ModalDialog
                shown={creatingTrait} 
                closeFunction={()=>{setCreatingTrait(false)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Create a New Trait`}
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <NewTrait 
                    close={()=>setCreatingTrait(false)} 
                    reload={()=>setReload(reload + 1)}
                />
            </ModalDialog>

            <ModalDialog
                shown={activeTrait !== null} 
                closeFunction={()=>{setActiveTrait(null)}} 
                actionFunction={()=>{}} 
                actionFunctionLabel={``}
                dialogTitle={`Edit Trait`}
                maxWidthClass='max-w-xl'
                hideActions={true}
            >
                <EditTrait 
                    trait={activeTrait} 
                    close={()=>setActiveTrait(null)} 
                    reload={()=>setReload(reload + 1)}
                />
            </ModalDialog> 

        </>
    )
}

export default Traits